import { render, staticRenderFns } from "./ReCardClientEdit.vue?vue&type=template&id=3cdcf43a&scoped=true"
import script from "./ReCardClientEdit.vue?vue&type=script&lang=js"
export * from "./ReCardClientEdit.vue?vue&type=script&lang=js"
import style0 from "./ReCardClientEdit.vue?vue&type=style&index=0&id=3cdcf43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdcf43a",
  null
  
)

export default component.exports